export const ROW_COLUMNS = [
  'articleNumber',
  'articleName',
  'ean',
  'action',
  'info',
  'commentKam',
  'samples',
  'categoryContact',
] as const;

export type RowColumn = typeof ROW_COLUMNS[number];

export const COLUMN_LABELS: Record<RowColumn, string> = {
  articleNumber: 'Artikelnummer',
  articleName: 'Produkt',
  ean: 'EAN',
  action: 'Åtgärd',
  info: 'Info',
  commentKam: 'Kommentar KAM',
  samples: 'Varuprover',
  categoryContact: 'Kategoriansvarig',
};

const draftWeek = (raw: string) => /^ny vecka( \d+)?$/i.test(raw.trim());

function shownAnnouncement(input: { announcementDate: string | null; announcementRaw: string }): string {
  if (input.announcementDate) return shortDate(input.announcementDate);
  if (!input.announcementRaw || draftWeek(input.announcementRaw)) return 'Utan datum';
  return input.announcementRaw;
}

export const ISSUE_LABELS: Record<string, string> = {
  malformed_date: 'Datumet behöver granskas',
  date_week_conflict: 'Vecka och datum stämmer inte',
  possible_duplicate: 'Möjlig dubblett',
  unsafe_identity: 'Osäkert artikelnummer',
  undated: 'Utan datum',
  ut: 'UT',
};

const MONTHS = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

export function shortDate(value: string | null): string {
  if (!value) return 'Utan datum';
  const [year, month, day] = value.split('-');
  const monthIndex = Number(month) - 1;
  if (!year || monthIndex < 0 || monthIndex > 11) return value;
  return `${Number(day)} ${MONTHS[monthIndex]} ${year}`;
}

export function announcementHeading(input: {
  announcementDate: string | null;
  announcementRaw: string;
  statedWeek: number | null;
}): string {
  const when = shownAnnouncement(input);
  return `Aviseras till kund ${when}${input.statedWeek ? ` · v${input.statedWeek}` : ''}`;
}

export function revisionLabel(input: { revisionWeek: number | null; revisionYear: number | null }): string | null {
  if (!input.revisionWeek) return null;
  return `Revideringsvecka v${input.revisionWeek}${input.revisionYear ? ` ${input.revisionYear}` : ''}`;
}

export function weekTitle(input: {
  announcementDate: string | null;
  announcementRaw: string;
  statedWeek: number | null;
  revisionWeek: number | null;
  revisionYear: number | null;
}): string {
  const when = shownAnnouncement(input);
  const stated = input.statedWeek ? ` · v${input.statedWeek}` : '';
  const revision = input.revisionWeek ? ` — Revideringsvecka v${input.revisionWeek}${input.revisionYear ? ` ${input.revisionYear}` : ''}` : '';
  return `Aviseras till kund ${when}${stated}${revision}`;
}

export function windowLabel(input: { announcement: string; revisionWeek?: number | null; revisionYear?: number | null }): string {
  const revision = input.revisionWeek ? ` · rev v${input.revisionWeek}${input.revisionYear ? ` ${input.revisionYear}` : ''}` : '';
  return `${input.announcement}${revision}`;
}
